export enum DocumentType {
  None = 0,
  SampleRegistrationAcknowledgement = 1,
  AnalyticalReport = 2,
  AnalyticalReportCopy = 3,
  InvoiceDocumentCopy = 4,
  InvoiceDocument = 5,
  OffSiteDocuments = 6,
  }
